import Avatar from "components/base/avatar/avatar";
import { formatChatDate } from "helpers/chatbot-modal.helper";
import React from "react";
import { ChatMessage } from "store/chat-bot/chat-bot-store";
import ReactMarkdown from "react-markdown";
import { stripCodeFences } from "helpers/markdown.helper";

interface ChatBotMessageProps {
	msg: ChatMessage;
	avatarTitle: string;
	avatarUrl?: string;
	isStreaming: boolean;
	userType: "user" | "bot";
}

const ChatBotMessage: React.FC<ChatBotMessageProps> = ({ msg, avatarTitle, avatarUrl, isStreaming, userType }) => {
	return (
		<div className="chat-message">
			<Avatar title={avatarTitle} image={avatarUrl} />

			<div className="chat-message__content">
				<div className="chat-message__header">
					<span className="chat-message__author">{msg.author}</span>
					<span className="chat-message__time">{formatChatDate(msg.time)}</span>
				</div>

				<div className="chat-message__text">
					{msg.text === "" && isStreaming ? (
						<div className="typing">...</div>
					) : msg.text ? (
						userType === "bot" ? (
							<div className="chat-message__markdown">
								<ReactMarkdown skipHtml>{stripCodeFences(msg.text)}</ReactMarkdown>
							</div>
						) : (
							msg.text
						)
					) : (
						"Can you clarify your question?"
					)}
				</div>
			</div>
		</div>
	);
};

export default ChatBotMessage;
